'use client';

import {
  IAtLinkGlobalFieldProps,
  IDefaultCsProps,
  IImageGlobalCSProps,
  TSpacingProp,
} from '@/lib/contentstack-sdk/types';
import {
  parseGlobalLinkFromCMS,
  parseImageFromCMS,
} from '@/lib/contentstack-sdk/utils/parseHelpers';
import { useEffect, useState } from 'react';
import { OrDesignStudioBlock } from './or-design-studio-block';
import { useModelHomes } from '@/hooks/useModelHomeData';
import {
  IDesignStudio,
  IOrDesignStudioBlockCMSProps,
} from './or-design-studio-block.types';

export const OrDesignStudioBlockCMS = ({
  main_cta,
  secondary_cta,
  header,
  design_studio_id,
  design_studio_image,
  design_studio_name,
  design_studio_address,
  design_studio_city,
  design_studio_state,
  design_studio_zip,
  top_spacing,
  bottom_spacing,
  header_variant,
  design_studio_variant,
  related_models_variant,
}: IOrDesignStudioBlockCMSProps) => {
  const mainCTA = parseGlobalLinkFromCMS(main_cta, 'or-design-studio-block');
  const secondaryCTA = parseGlobalLinkFromCMS(
    secondary_cta,
    'or-design-studio-block',
  );

  const [designStudio, setDesignStudio] = useState<IDesignStudio>();
  const ctaProps = mainCTA && secondaryCTA ? [mainCTA, secondaryCTA] : [];
  const { getStudioModelHomes } = useModelHomes();
  useEffect(() => {
    const fetchDesignStudio = async () => {
      try {
        const designStudio = {
          Name: design_studio_name,
          Id: parseInt(design_studio_id?.location?.[0]),
          Address: design_studio_address,
          City: design_studio_city,
          State: design_studio_state,
          Zip: design_studio_zip,
          objectID: design_studio_id?.location?.[0],
        } as IDesignStudio;

        const relatedHomePlans = getStudioModelHomes(
          parseInt(design_studio_id?.location?.[0]),
        );

        designStudio.relatedModels = relatedHomePlans;
        designStudio.image = parseImageFromCMS(design_studio_image);
        setDesignStudio(designStudio);
      } catch (e) {
        console.error('Error fetching design studio', e);
      }
    };

    fetchDesignStudio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OrDesignStudioBlock
      ctaProps={ctaProps}
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
      title={header}
      designStudio={designStudio}
      titleVariant={header_variant?.select || undefined}
      designStudioNameVariant={design_studio_variant?.select || undefined}
      relatedModelsVariant={related_models_variant?.select || undefined}
    />
  );
};
